"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorCode = exports.CustomError = void 0;
class CustomError extends Error {
    constructor(code, message) {
        super(message);
        this.code = code;
        this.name = 'CustomError';
    }
}
exports.CustomError = CustomError;
// Define specific error codes
exports.errorCode = {
    invalidMutiplier: 'INVALID_MULTIPLIER',
    invalidTimeFrame: 'INVALID_TIME_FRAME',
    invalidDate: 'INVALID_DATE',
    invalidDateRange: 'INVALID_DATE_RANGE',
    missingSeriesData: 'MISSING_SERIES_DATA',
    invalidFrequency: 'INVALID_FREQUENCY',
    invalidRepeatEvery: 'INVALID_REPEAT_EVERY',
    invalidFormat: 'INVALID_FORMAT',
    invalidArray: 'INVALID_ARRAY',
    invalidInteger: 'INVALID_INTEGER',
};
//# sourceMappingURL=errors.js.map